<app-modal-container
  [title]="task.name"
  (dismissModal)="closeModal()"
  [showFooter]="true"
  data-testid="deadline-task-assignee-modal"
>
  <div footer>
    <div class="d-flex justify-content-end gap-2">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="closeModal()"
        [disabled]="isSaving"
      >
        Annuler
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="updateAssignee()"
        [disabled]="isSaving || !assigneeForm.valid"
      >
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        Mettre à jour
      </button>
    </div>
  </div>
  <div body>
    <form [formGroup]="assigneeForm" (ngSubmit)="updateAssignee()">
      <div class="card">
        <div class="card-body">
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label">
                {{ "taskDescriptionModal.assignedTo" | translate }} *
              </label>
              <app-dropdown-select
                apiUrl="user_firms"
                    [apiFilters]="{ 'userInfo.isEnabled': true }"
                formControlName="executor"
                [isMultiSelect]="false"
                [itemsPerPage]="100"
                [placeHolder]="'taskDescriptionModal.assignedToUserPlaceholder' | translate"
                [returnFullItem]="true"
                [itemValueKey]="'user'"
                [itemLabelKey]="'fullName'"
                [searchKey]="'user.fullName'"
              ></app-dropdown-select>
              <div
                *ngIf="submitted && assigneeForm.get('executor')?.hasError('required')"
                class="text-danger"
              >
                {{ "taskDescriptionModal.requierd" | translate }}
              </div>
            </div>

            <div class="col-6">
              <label class="form-label">
                {{ getDateLabel() }} *
              </label>
              <div class="input-group input-group-sm">
                <input
                  class="form-control"
                  formControlName="plannedDate"
                  ngbDatepicker
                  #dd="ngbDatepicker"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-secondary"
                    type="button"
                    (click)="dd.toggle()"
                  >
                    <i class="fas fa-calendar-alt"></i>
                  </button>
                </div>
              </div>
              <div
                *ngIf="submitted && assigneeForm.get('plannedDate')?.hasError('required')"
                class="text-danger"
              >
                {{ "taskDescriptionModal.requierd" | translate }}
              </div>
            </div>

            <div class="col-6">
              <label class="form-label">
                {{ "taskDescriptionModal.plannedDuration" | translate }} *
              </label>
              <input
                type="text"
                inputmode="decimal"
                class="form-control text-end"
                formControlName="duration"
                placeholder="Durée"
              />
              <div
                *ngIf="submitted && assigneeForm.get('duration')?.hasError('required')"
                class="text-danger"
              >
                {{ "taskDescriptionModal.requierd" | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Loader -->
      <div *ngIf="isSaving" class="text-center my-2">
        <span
          class="spinner-border spinner-border-sm text-primary"
          role="status"
          aria-hidden="true"
        ></span>
        <span class="ms-2">{{ "cardForm.saving" | translate }}</span>
      </div>
    </form>
  </div>
</app-modal-container>
